export default __webpack_public_path__ + "static/media/business_icon.a286a0b1.svg";